export class LoginRequest {
    Username: string | undefined;
    Password: string | undefined;
}